const ClientRoutes = [
  {
    path: '/apps',
    name: 'apps',
    component: () => import('@/views/client/ApplicationManager'),
    meta: { requiresAuth: true, roles: ['client'] }
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: () => import('@/views/client/AnalyticsView'),
    meta: { requiresAuth: true, roles: ['client'] }
  },
  {
    path: '/assets',
    name: 'assets',
    component: () => import('@/views/client/AssetManager'),
    meta: { requiresAuth: true, roles: ['client'] }
  },
  {
    path: '/client',
    name: 'client',
    component: () => import('@/views/client/DashboardView'),
    meta: { requiresAuth: true, roles: ['client'] }
  },
  {
    path: '/promos',
    name: 'promos',
    component: () => import('@/views/client/PromoManager'),
    meta: { requiresAuth: true, roles: ['client'] }
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: () => import('@/views/client/ScheduleManager'),
    meta: { requiresAuth: true, roles: ['client'] }
  },
  {
    path: '/leads',
    name: 'leads',
    component: () => import('@/views/client/LeadManager'),
    meta: { requiresAuth: true, roles: ['client'] }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/client/SettingsManager'),
    meta: { requiresAuth: true, roles: ['client'] }
  },
]

export default ClientRoutes